import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { BudgetComponent } from '../budget/budget.component';
@Component({
  selector: 'app-workplan-list',
  templateUrl: './workplan-list.component.html',
  styleUrls: ['./workplan-list.component.css'],
})
export class WorkplanListComponent implements OnInit {
  @ViewChild('budgetComponent') budgetComponent!: BudgetComponent;
  workplan: FormGroup;
  private saveApi = environment.url + 'coe/workplan/save';
  private getApi = environment.url + 'coe/workplan/get?id=';
  constructor(
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog
  ) {
    this.workplan = this.fb.group({
      id: [0],
      applicationId: [sessionStorage.getItem('applicationId')],
      yearWiseWorkPlan: [''],
      yearWiseWorkPlanDoc: [''],
      newTechnologyYear1: [
        '',
        [Validators.required, Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      newTechnologyYear2: [
        '',
        [Validators.required, Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      newTechnologyTotalYear: [''],
      newEntrepreneursYear1: [
        '',
        [Validators.required, Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      newEntrepreneursYear2: [
        '',
        [Validators.required, Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      newEntrepreneursTotalYear: [''],
      productsCommercializedYear1: [
        '',
        [Validators.required, Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      productsCommercializedYear2: [
        '',
        [Validators.required, Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      productsCommercializedTotalYear: [''],
      trainingProgramsYear1: [
        '',
        [Validators.required, Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      trainingProgramsYear2: [
        '',
        [Validators.required, Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      trainingProgramsTotaYear: [''],
      investibleStartupsYear1: [
        '',
        [Validators.required, Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      investibleStartupsYear2: [
        '',
        [Validators.required, Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      investibleStartupsTotalYear: [''],
      innovationsSupportedYear1: [
        '',
        [Validators.required, Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      innovationsSupportedYear2: [
        '',
        [Validators.required, Validators.pattern(/^\d{0,8}(\.\d{0,2})?$/)],
      ],
      innovationsSupportedTotalYear: [''],
    });
  }

  ngOnInit(): void {
    this.getDataApi();
  }
  // reset form
  resetForm(): void {
    if (this.getId == 0) {
      this.workplan.reset();
      this.FileValue = '';
      this.FileName = '';
      this.disNames = '';
      this.disName = '';
    }
  }
  Optionsonechecked;
  // calculate total
  calculateTotal1(): void {
    const year1 =
      parseFloat(this.workplan.get('newTechnologyYear1')?.value) || 0;
    const year2 =
      parseFloat(this.workplan.get('newTechnologyYear2')?.value) || 0;
    const total = parseFloat((year1 + year2).toFixed(2));
    this.workplan.get('newTechnologyTotalYear')?.setValue(total);
  }
  // calculate total
  calculateTotal2(): void {
    const year1 =
      parseFloat(this.workplan.get('newEntrepreneursYear1')?.value) || 0;
    const year2 =
      parseFloat(this.workplan.get('newEntrepreneursYear2')?.value) || 0;
    const total = parseFloat((year1 + year2).toFixed(2));
    this.workplan.get('newEntrepreneursTotalYear')?.setValue(total);
  }
  // calculate total
  calculateTotal3(): void {
    const year1 =
      parseFloat(this.workplan.get('productsCommercializedYear1')?.value) || 0;
    const year2 =
      parseFloat(this.workplan.get('productsCommercializedYear2')?.value) || 0;
    const total = parseFloat((year1 + year2).toFixed(2));
    this.workplan.get('productsCommercializedTotalYear')?.setValue(total);
  }
  // calculate total
  calculateTotal4(): void {
    const year1 =
      parseFloat(this.workplan.get('trainingProgramsYear1')?.value) || 0;
    const year2 =
      parseFloat(this.workplan.get('trainingProgramsYear2')?.value) || 0;
    const total = parseFloat((year1 + year2).toFixed(2));
    this.workplan.get('trainingProgramsTotaYear')?.setValue(total);
  }
  // calculate total
  calculateTotal5(): void {
    const year1 =
      parseFloat(this.workplan.get('investibleStartupsYear1')?.value) || 0;
    const year2 =
      parseFloat(this.workplan.get('investibleStartupsYear2')?.value) || 0;
    const total = parseFloat((year1 + year2).toFixed(2));
    this.workplan.get('investibleStartupsTotalYear')?.setValue(total);
  }
  // calculate total
  calculateTotal6(): void {
    const year1 =
      parseFloat(this.workplan.get('innovationsSupportedYear1')?.value) || 0;
    const year2 =
      parseFloat(this.workplan.get('innovationsSupportedYear2')?.value) || 0;
    const total = parseFloat((year1 + year2).toFixed(2));
    this.workplan.get('innovationsSupportedTotalYear')?.setValue(total);
  }
  showForm: boolean = false;
  get setting() {
    return this.workplan.controls;
  }

  getValue: any = {};
  disableBtn: boolean;
  show;
  getId;
  // get data
  getDataApi() {
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('applicationId'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.getValue = data;
        this.getId = data.id;
        if (data.edit === false) {
          this.showForm = true;
        } else {
          this.showForm = false;
        }
        if (data.responseStatus != 'Failed') {
          this.workplan.patchValue(data);
          if (this.getValue.yearWiseWorkPlanDoc) {
            this.FileValue = this.getValue.yearWiseWorkPlanDoc;
            this.FileName = this.getValue.yearWiseWorkPlan;
            this.disNames = '✔ Uploaded';
            this.disName = '✔ Uploaded';
          }
        }
      });
  }
  selecetdFile: any = [];
  url: any;
  FileValue: any = '';
  FileName: any;
  documentValues = [];
  disName;
  disNames;
  maxSizeMB = 5;
  logoCheck = false;
  fileErrorShow = false;
  fileError = false;
  // file upload
  fileUpload(event) {
    this.selecetdFile = event.target.files[0];
    if (event.target.files && this.selecetdFile) {
      const fileSizeMB = this.selecetdFile.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile);
        reader.onload = () => {
          this.url = reader.result;
          let spl = this.url.split(',');
          this.FileValue = spl[1];
          this.FileName = this.selecetdFile.name;
          this.disName = '✔ Uploaded';
          this.fileError = false;
          this.fileErrorShow = false;
          this.notify.notifysuccess('File Upload Success !');
        };
      } else {
        this.notify.notifyError('Only *pdf format are allowed');
      }
    }
  }
  // cancle
  cancleBtn() {
    this.fileError = true;
    this.FileValue = '';
    this.FileName = '';
    this.disName = '';
    this.fileError = true;
    this.showForm = false;
    this.workplan.reset();
  }
  // target milestone
  targetMilestoneFalse() {
    this.workplan.controls['newTechnologyYear1'].setValue('');
    this.workplan.controls['newTechnologyYear1'].clearValidators();
    this.workplan.controls['newTechnologyYear1'].updateValueAndValidity();
    this.workplan.controls['newTechnologyYear2'].setValue('');
    this.workplan.controls['newTechnologyYear2'].clearValidators();
    this.workplan.controls['newTechnologyYear2'].updateValueAndValidity();
    this.workplan.controls['newTechnologyTotalYear'].setValue('');
    this.workplan.controls['newTechnologyTotalYear'].clearValidators();
    this.workplan.controls['newTechnologyTotalYear'].updateValueAndValidity();

    this.workplan.controls['newEntrepreneursYear1'].setValue('');
    this.workplan.controls['newEntrepreneursYear1'].clearValidators();
    this.workplan.controls['newEntrepreneursYear1'].updateValueAndValidity();
    this.workplan.controls['newEntrepreneursYear2'].setValue('');
    this.workplan.controls['newEntrepreneursYear2'].clearValidators();
    this.workplan.controls['newEntrepreneursYear2'].updateValueAndValidity();
    this.workplan.controls['newEntrepreneursTotalYear'].setValue('');
    this.workplan.controls['newEntrepreneursTotalYear'].clearValidators();
    this.workplan.controls[
      'newEntrepreneursTotalYear'
    ].updateValueAndValidity();

    this.workplan.controls['productsCommercializedYear1'].setValue('');
    this.workplan.controls['productsCommercializedYear1'].clearValidators();
    this.workplan.controls[
      'productsCommercializedYear1'
    ].updateValueAndValidity();
    this.workplan.controls['productsCommercializedYear2'].setValue('');
    this.workplan.controls['productsCommercializedYear2'].clearValidators();
    this.workplan.controls[
      'productsCommercializedYear2'
    ].updateValueAndValidity();
    this.workplan.controls['productsCommercializedTotalYear'].setValue('');
    this.workplan.controls['productsCommercializedTotalYear'].clearValidators();
    this.workplan.controls[
      'productsCommercializedTotalYear'
    ].updateValueAndValidity();

    this.workplan.controls['trainingProgramsYear1'].setValue('');
    this.workplan.controls['trainingProgramsYear1'].clearValidators();
    this.workplan.controls['trainingProgramsYear1'].updateValueAndValidity();
    this.workplan.controls['trainingProgramsYear2'].setValue('');
    this.workplan.controls['trainingProgramsYear2'].clearValidators();
    this.workplan.controls['trainingProgramsYear2'].updateValueAndValidity();
    this.workplan.controls['trainingProgramsTotaYear'].setValue('');
    this.workplan.controls['trainingProgramsTotaYear'].clearValidators();
    this.workplan.controls['trainingProgramsTotaYear'].updateValueAndValidity();

    this.workplan.controls['investibleStartupsYear1'].setValue('');
    this.workplan.controls['investibleStartupsYear1'].clearValidators();
    this.workplan.controls['investibleStartupsYear1'].updateValueAndValidity();
    this.workplan.controls['investibleStartupsYear2'].setValue('');
    this.workplan.controls['investibleStartupsYear2'].clearValidators();
    this.workplan.controls['investibleStartupsYear2'].updateValueAndValidity();
    this.workplan.controls['investibleStartupsTotalYear'].setValue('');
    this.workplan.controls['investibleStartupsTotalYear'].clearValidators();
    this.workplan.controls[
      'investibleStartupsTotalYear'
    ].updateValueAndValidity();

    this.workplan.controls['innovationsSupportedYear1'].setValue('');
    this.workplan.controls['innovationsSupportedYear1'].clearValidators();
    this.workplan.controls[
      'innovationsSupportedYear1'
    ].updateValueAndValidity();
    this.workplan.controls['innovationsSupportedYear2'].setValue('');
    this.workplan.controls['innovationsSupportedYear2'].clearValidators();
    this.workplan.controls[
      'innovationsSupportedYear2'
    ].updateValueAndValidity();
    this.workplan.controls['innovationsSupportedTotalYear'].setValue('');
    this.workplan.controls['innovationsSupportedTotalYear'].clearValidators();
    this.workplan.controls[
      'innovationsSupportedTotalYear'
    ].updateValueAndValidity();
  }
  // target milestone
  showOptionsone(event) {
    if (event == 'false') {
      this.targetMilestoneFalse();
    } else {
      this.workplan.controls['newTechnologyYear1'].setValidators([
        Validators.required,
      ]);
      this.workplan.controls['newTechnologyYear2'].setValidators([
        Validators.required,
      ]);
      this.workplan.controls['newEntrepreneursYear1'].setValidators([
        Validators.required,
      ]);
      this.workplan.controls['newEntrepreneursYear2'].setValidators([
        Validators.required,
      ]);
      this.workplan.controls['productsCommercializedYear1'].setValidators([
        Validators.required,
      ]);
      this.workplan.controls['productsCommercializedYear2'].setValidators([
        Validators.required,
      ]);
      this.workplan.controls['trainingProgramsYear1'].setValidators([
        Validators.required,
      ]);
      this.workplan.controls['trainingProgramsYear2'].setValidators([
        Validators.required,
      ]);
      this.workplan.controls['investibleStartupsYear1'].setValidators([
        Validators.required,
      ]);
      this.workplan.controls['investibleStartupsYear2'].setValidators([
        Validators.required,
      ]);
      this.workplan.controls['innovationsSupportedYear1'].setValidators([
        Validators.required,
      ]);
      this.workplan.controls['innovationsSupportedYear2'].setValidators([
        Validators.required,
      ]);
    }
  }
  // Prevent the Enter key from submitting the form
  preventEnterKey(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent the default action
    }
  }
  @Input() parent: any;
  // save
  saveBtn() {
    let getform = this.workplan.value;
    if (this.workplan.invalid) {
      this.workplan.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      if (this.FileValue != '') {
        this.fileError = false;
        getform.yearWiseWorkPlan = this.FileName;
        getform.yearWiseWorkPlanDoc = this.FileValue;
      }

      getform.applicationId = sessionStorage.getItem('applicationId');
      if (this.fileError == false) {
        this.getdata.amizhthLoader('show');
        this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
          this.getdata.amizhthLoader('hide');
          this.fileErrorShow = false;
          if (data.responseStatus == 'Success') {
            this.notify.notifysuccess(data.responseStatus);
            this.getDataApi();

            if (this.parent) {
              this.parent.navigateToTab(1);
            }
          } else {
            this.notify.notifyError(data.responseStatus);
          }
        });
      }
    }
  }
}
